import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-utilidad',
  templateUrl: './utilidad.component.html',
  styleUrls: ['./utilidad.component.css']
})
export class UtilidadComponent implements OnInit {

  
  url:string;
  urlSafe: SafeResourceUrl;
  
    constructor(public sanitizer: DomSanitizer) { }
  
    ngOnInit() {
      this.url=environment.apiReportes+"utilidad1.rptdesign&idEmisor="+localStorage.getItem('id');
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
   
    }

}
